import React, { useContext } from "react";
import "./Header.scss";

// Utils
import { NavItems } from "../../utils";
import { useViewport } from "../../utils/useViewport";

// Components
import { IonBackButton, IonButton, IonButtons, IonHeader, IonIcon, IonMenuButton, IonRouterLink, IonTitle, IonToolbar, useIonRouter } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { DesktopNav } from "../Navigation/index";

// Context
import { AuthenticatedUserContext } from "../../contexts/AuthenticatedUserContext";
import { useSettings } from "../../contexts/SettingsContext";

// Icons
import { faArrowLeft, faArrowRightFromBracket, faGear, faUser } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { chevronBack } from "ionicons/icons";

const Header: React.FC<any> = (props) => {
  const { t } = useTranslation();
  const { settings } = useSettings();
  const { member } = useContext(AuthenticatedUserContext);
  const navItems = NavItems();
  const { isDesktop } = useViewport();
  const router = useIonRouter();
  navItems.push({ title: t("register"), desktop: true, mobile: true, active: window.location.pathname.startsWith("/register"), showOnMenu: true });

  const backButton = () => {
    return (
      !props.hideBackButton &&
      (isDesktop ? (
        <button className="header__back header__back--button" onClick={props.backButtonOnClick}>
          <FontAwesomeIcon icon={faArrowLeft} />
          {t("back")}
        </button>
      ) : props.backButtonOnClick ? (
        <IonButton
          className="header__back"
          color="default"
          fill={"clear"}
          onClick={() => {
            props.backButtonOnClick(router);
          }}
        >
          <IonIcon
            icon={chevronBack}
            slot={"start"}
            style={{
              marginRight: 0,
            }}
          />{" "}
          {t("back")}
        </IonButton>
      ) : (
        <IonBackButton className="header__back" text={t("back")} />
      ))
    );
  };

  const hamburger = () =>
    !props.hideHamburger && (
      <IonMenuButton className="header__hamburger" menu="mobileNav" autoHide={false} color="dark">
        <IonIcon className="header__hamburger__icon" src="../../assets/icons/hamburger.svg" slot="icon" />
      </IonMenuButton>
    );

  const logo = () => {
    return isDesktop ? (
      <img src={settings?.brand?.img_path_admin_header_logo || "/assets/logo-white.svg"} alt={`${t("instance")} logo`} className="header__logo" width="130px" />
    ) : (
      <img src={settings?.brand?.img_path_app_header_logo || "/assets/logo-white-icon.svg"} alt={`${t("instance")} logo`} className="header__logo" width="34px" />
    );
  };

  return isDesktop ? (
    <IonHeader className="header">
      <div className="header__row">
        <div>
          {member?.user?.id && (
            <div className="header-active-user">
              <div className="header-active-user__name">
                {t("loggedInAs")}
                <span>{member.nickname}</span>
              </div>
            </div>
          )}

          <div className="header-active-user__sign-out">
            <IonRouterLink routerLink="/profile">
              <FontAwesomeIcon icon={faUser} className={"header-active-user__sign-out__icon"} />
              <span>{t("myProfile")}</span>
            </IonRouterLink>
            <IonRouterLink routerLink="/account">
              <FontAwesomeIcon icon={faGear} className={"header-active-user__sign-out__icon"} />
              <span>{t("myAccount")}</span>
            </IonRouterLink>
            <IonRouterLink routerLink="/sign-out">
              <FontAwesomeIcon icon={faArrowRightFromBracket} className={"header-active-user__sign-out__icon"} />
              <span>{t("logOut")}</span>
            </IonRouterLink>
          </div>
        </div>
        {props.hideBackButton ? logo() : <div>{backButton()}</div>}
        <div>
          {hamburger()}
          <DesktopNav />
        </div>
      </div>
    </IonHeader>
  ) : (
    props.title && (
      <IonHeader translucent={true}>
        <IonToolbar>
          {!props.hideBackButton && <IonButtons slot="start">{backButton()}</IonButtons>}
          <IonTitle>{props.title}</IonTitle>
        </IonToolbar>
      </IonHeader>
    )
  );
};

export default Header;
// export default withIonLifeCycle(Header);
